"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function cleanUnit(value) {
    return parseFloat(value.replace(/[a-zA-Z]/g, ''));
}
function typography(theme) {
    const fontInPx = theme.remToPx(cleanUnit(theme.font.size.xs));
    return {
        fontFamily: theme.font.family.base,
        fontSize: fontInPx,
        body1: {
            fontFamily: theme.font.family.base,
            fontSize: fontInPx,
            fontWeight: theme.font.weight.regular
        },
        body2: {
            fontFamily: theme.font.family.base,
            fontSize: fontInPx,
            fontWeight: theme.font.weight.regular
        },
        button: {
            fontWeight: theme.font.weight.semibold
        }
    };
}
exports.default = typography;
